module.exports = __webpack_public_path__ + "img/upload.3b9d0e8e.png";